'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (entity, text, options) {
  var cashtag = (0, _htmlEscape2.default)(entity.cashtag);
  var attrs = (0, _clone2.default)(options.htmlAttrs || {});
  attrs.href = options.cashtagUrlBase + cashtag;
  attrs.title = '$' + cashtag;
  attrs['class'] = options.cashtagClass;
  if (options.targetBlank) {
    attrs.target = '_blank';
  }

  return (0, _linkToTextWithSymbol2.default)(entity, '$', cashtag, attrs, options);
};

var _clone = require('./lib/clone');

var _clone2 = _interopRequireDefault(_clone);

var _htmlEscape = require('./htmlEscape');

var _htmlEscape2 = _interopRequireDefault(_htmlEscape);

var _linkToTextWithSymbol = require('./linkToTextWithSymbol');

var _linkToTextWithSymbol2 = _interopRequireDefault(_linkToTextWithSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];